import { render, staticRenderFns } from "./volume-funding-viewer-summary-header.vue?vue&type=template&id=2cdb5248&scoped=true"
import script from "./volume-funding-viewer-summary-header.vue?vue&type=script&lang=js"
export * from "./volume-funding-viewer-summary-header.vue?vue&type=script&lang=js"
import style0 from "./volume-funding-viewer-summary-header.vue?vue&type=style&index=0&id=2cdb5248&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdb5248",
  null
  
)

export default component.exports